const config = {
  // apiBaseUrl: 'https://www.curatoreden.com',
  apiBaseUrl: process.env.NODE_ENV === 'production' ? 'https://www.curatoreden.com' : 'http://localhost:3000',
};

export default config; 